// extracted by mini-css-extract-plugin
module.exports = {"article-fact":"article-fact___RO38f","articleFact":"article-fact___RO38f","fact":"fact___y8xlb","source":"source___pPN_9"};